import { FC, useState } from 'react';
import FormMapper from './FormsBucket/FormMapper';
import List from './List';
import ListDragAndDrop from './ListDragAndDrop/ListDragAndDrop';
import useQuickForm from './QuickForm.hook';
import { QuickFormProps } from './QuickForm.types';
import { YodaFieldValue } from 'services/yodaForm/yodaForm.types';
import Box from 'yoda-ui/Box';

const QuickForm: FC<QuickFormProps> = ({
  name,
  form,
  handleRemoveItemAsync,
  list,
  transformToCard,
  transformToState = (item: YodaFieldValue) => item,
  defaultValue,
  validation,
  disabled = false,
}) => {
  const { fieldErrorMessage, fieldState, setFieldState, handleRemoveItem } = useQuickForm({
    name,
    validation,
    defaultValue,
  });

  const [listLoading, setListLoading] = useState(false);

  // Allow to do some async logic before modifying the state
  const computedHandleRemoveItem = async (id: string) => {
    if (handleRemoveItemAsync) {
      await handleRemoveItemAsync(id);
    } else {
      handleRemoveItem(id);
    }
  };

  return (
    <>
      <FormMapper
        form={ form }
        setFieldState={ setFieldState }
        setListLoading={ setListLoading }
        fieldState={ fieldState }
        transformToState={ transformToState }
        disabled={ disabled }
      />
      {
        list && transformToCard && list.dragAndDrop && (<ListDragAndDrop
          list={ list }
          loading={ listLoading }
          setFieldState={ setFieldState }
          fieldState={ fieldState }
          handleRemoveItem={ computedHandleRemoveItem }
          transformToCard={ transformToCard }
          disabled={ disabled }
        />)
      }
      {
        list && transformToCard && !list.dragAndDrop && (<List
          list={ list }
          loading={ listLoading }
          setFieldState={ setFieldState }
          fieldState={ fieldState }
          handleRemoveItem={ computedHandleRemoveItem }
          transformToCard={ transformToCard }
          disabled={ disabled }
        />)
      }
      {
        fieldErrorMessage && (
          <Box>{ fieldErrorMessage }</Box>
        )
      }
    </>
  );
};

export default QuickForm;
